/**
 * WHO MAY CORRECT A RECORD AFTER THE FACT.
 *
 * Two actions rewrite something already on file: editing a patient's
 * registration details (Patient Record → Edit) and asking for a recorded
 * payment to be corrected (OP receipt → Request Correction). Owner's call
 * 2026-10-03: neither is offered to anyone but this one account.
 *
 * This is deliberately an ACCOUNT check, not a permission or a role. A
 * permission is granted to a role, and every role that registers patients or
 * takes payments already holds the ones these actions need — so no permission
 * edit could single one login out. Moving it onto a permission later is a
 * one-line change here.
 *
 * THIS ONLY DECIDES WHAT THE SCREEN OFFERS. The server still gates each route
 * on its own permission and does not look at the email.
 */
export const RECORD_CORRECTION_OPERATOR_EMAIL = 'csihmhdevelopment@gmail.com';

/** Logins are matched case-insensitively — the address is the same mailbox however it was typed. */
export function isRecordCorrectionOperator(email: string | null | undefined): boolean {
  return typeof email === 'string' && email.trim().toLowerCase() === RECORD_CORRECTION_OPERATOR_EMAIL;
}
